<template>
  <transition
    name="magnet"
    appear
  >
    <slot
      name="content"
    />
  </transition>
</template>

<script>
export default {
  name: 'OwalTransitionChangeMe',
}
</script>

<style scoped>
.magnet-enter-active {
  animation-name: magnet-fall;
  animation-duration: 700ms;
  animation-timing-function: ease-in;
}

.magnet-leave-active, .magnet-leave-to {
  animation-name: magnet-pull;
  animation-duration: 700ms;
  animation-timing-function: ease-in;
  animation-direction: reverse;
}

/* --- Magnet: Snap upwards, as if magnetically attaching to an invisible surface. --- */

@keyframes magnet-pull {
  0% {
    opacity: 0;
    transform: translateY(90rem);
  }
  90% {
    transform: translateY(-1rem);
  }
  95% {
    transform: translateY(.5rem);
  }
  100% {
    opacity: 1;
    transform: initial;
  }
}

@keyframes magnet-fall {
  0% {
    transform: initial;
  }
  10% {
    transform: translateY(-2rem);
  }
  15% {
    transform: translateY(-2rem);
  }
  100% {
    transform: translateY(100rem);
  }
}

</style>
